import { render, staticRenderFns } from "./abou_us.vue?vue&type=template&id=f8e1a17e&scoped=true"
import script from "./abou_us.vue?vue&type=script&lang=js"
export * from "./abou_us.vue?vue&type=script&lang=js"
import style0 from "./abou_us.vue?vue&type=style&index=0&id=f8e1a17e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e1a17e",
  null
  
)

export default component.exports